import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { ApiKeysPage } from '@/containers/settings/api-keys-container.component';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/api-keys')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Head heading='API keys' />
      <AuthCheck>
        <SettingsLayout>
          <ApiKeysPage />
        </SettingsLayout>
      </AuthCheck>
    </>
  );
}
